<!-- =========================================================================================
    File Name: VxSidebar.vue
    Description: Sidebar Component
    Component Name: VxSidebar
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="parentx">
        <vs-sidebar v-hammer:swipe.left="onSwipeLeft" ref="mainSidebar" :parent="parent" :hiddenBackground="clickNotClose"
            :reduce="reduce" default-index="-1" class="sidebarx main-menu-sidebar items-no-padding"
            v-model="isSidebarActive" :click-not-close="clickNotClose" :reduce-not-rebound="reduceNotRebound">
            <div @mouseenter="sidebarMouseEntered" @mouseleave="sidebarMouseLeave">
                <div class="header-sidebar flex items-end justify-between bg-light" slot="header">
                    <div class="logo flex items-center" style="max-width: 100%;">
                        <img :src="logo" alt="logo" class="w-10 mr-4" v-if="logo" v-show="reduce && !isMouseEnter"
                            style="max-width: 80%">
                        <img :src="logo" alt="logo" class="mr-4" v-if="logo" v-show="isMouseEnter || !reduce"
                            style="max-width: 80%">
                        <!-- <span class="logo-text" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span> -->
                    </div>
                    <div>
                        <template v-if="showCloseButton">
                            <feather-icon icon="XIcon" class="m-0 cursor-pointer"
                                @click="$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)"></feather-icon>
                        </template>
                        <template v-else-if="!showCloseButton && !sidebarItemsMin">
                            <feather-icon icon="DiscIcon" class="mr-0 cursor-pointer" svg-classes="stroke-current"
                                v-show="!reduce" @click="toggleReduce(true)" id="btnSidebarToggler"></feather-icon>
                            <feather-icon icon="CircleIcon" class="mr-0 cursor-pointer" svg-classes="stroke-current"
                                v-show="reduce" @click="toggleReduce(false)" id="btnSidebarToggler"></feather-icon>
                        </template>
                    </div>
                </div>

                <div class="shadow-bottom" v-show="showShadowBottom"></div>

                <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--main-sidebar pt-2" :settings="settings"
                    @ps-scroll-y="psSectionScroll">
                    <template v-for="(sidebarItem, index) in finalSidebarItems">
                        <!-- GROUP ITEM HEADER -->
                        <span :key="`header-${index}`" v-if="sidebarItem.header && !sidebarItemsMin"
                            class="navigation-header truncate">{{ $t(sidebarItem.i18n) || sidebarItem.header }}</span>
                        <template v-else-if="!sidebarItem.header">

                            <!-- IF IT'S SINGLE ITEM -->
                            <vx-sidebar-item ref="sidebarLink" :key="`sidebarItem-${index}`" v-if="!sidebarItem.submenu"
                                :index="index" :to="sidebarItem.slug != 'external' ? sidebarItem.url : ''"
                                :href="sidebarItem.slug == 'external' ? sidebarItem.url : ''" :icon="sidebarItem.icon"
                                :target="sidebarItem.target" :isDisabled="sidebarItem.isDisabled" :slug="sidebarItem.slug">
                                <span v-show="!sidebarItemsMin" class="truncate">{{ $t(sidebarItem.i18n) || sidebarItem.name
                                }}</span>
                                <vs-chip class="ml-auto" :color="sidebarItem.tagColor"
                                    v-if="sidebarItem.tag && (isMouseEnter || !reduce)">{{ sidebarItem.tag }}</vs-chip>
                            </vx-sidebar-item>

                            <!-- IF HAVE SUBMENU / DROPDOWN -->
                            <template v-else>
                                <vx-sidebar-group ref="sidebarGrp" :key="`group-${index}`" :openHover="openGroupHover"
                                    :group="sidebarItem" :groupIndex="index" :open="isGroupActive(sidebarItem)"
                                    v-if="canSee(sidebarItem)"></vx-sidebar-group>
                            </template>
                        </template>
                    </template>
                </VuePerfectScrollbar>
            </div>
        </vs-sidebar>
        <div v-hammer:swipe.right="onSwipeRightSidebarSwipeArea" v-if="!isSidebarActive" class="sidebar-swipe-area"
            id="sidebar-swipe-area"></div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VxSidebarGroup from './VxSidebarGroup.vue'
import VxSidebarItem from './VxSidebarItem.vue'

export default {
    name: 'vx-sidebar',
    props: {
        sidebarItems: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
        },
        logo: {
            type: String
        },
        parent: {
            type: String
        },
        openGroupHover: {
            type: Boolean,
            default: false
        },
        reduceNotRebound: {
            type: Boolean,
            default: true,
        }
    },
    data: () => ({
        clickNotClose: false, // disable close sidebar on outside click
        reduce: false, // determines if sidebar is reduce - component property
        showCloseButton: false, // show close button in smaller devices
        isMouseEnter: false,
        settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: 1,
            swipeEasing: true
        },
        windowWidth: window.innerWidth, //width of windows
        showShadowBottom: false,
        finalSidebarItems: []
    }),
    computed: {
        isSidebarActive: {
            get() {
                return this.$store.state.isSidebarActive
            },
            set(val) {
                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', val)
            }
        },
        reduceSidebar() {
            return Boolean(this.reduce && this.reduceButton)
        },
        reduceButton: {
            get() {
                return this.$store.state.reduceButton;
            },
            set(val) {
                this.$store.commit('TOGGLE_REDUCE_BUTTON', val)
            }
        },
        sidebarItemsMin() {
            return this.$store.state.sidebarItemsMin;
        },
        isGroupActive() {
            return (sidebarItem) => {
                const path = this.$route.fullPath;
                let open = false;
                let func = function (sidebarItem) {
                    if (sidebarItem.submenu) {
                        sidebarItem.submenu.forEach((item) => {
                            if (path == item.url) { open = true }
                            else if (item.submenu) { func(item) }
                        })
                    }
                }
                func(sidebarItem)
                return open
            }
        }
    },
    watch: {
        reduce(val) {

            if (val == true) {
                this.$store.dispatch('updateSidebarWidth', 'reduced');
            } else {
                this.$store.dispatch('updateSidebarWidth', 'default');
            }

            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        },
        reduceButton() {
            this.setSidebarWidth();
        },
        '$route'() {
            if (this.isSidebarActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
        },
        '$store.state.auth.userRole'() {
            this.addStoreMenu()
        },
    },
    methods: {
        sidebarMouseEntered() {
            if (this.reduce) this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
            this.isMouseEnter = true;
        },
        sidebarMouseLeave() {
            if (this.reduce) {
                this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true);
            }
            this.isMouseEnter = false;
        },
        toggleReduce(val) {
            this.reduceButton = val;
            this.setSidebarWidth();
        },
        handleWindowResize(event) {
            this.windowWidth = event.currentTarget.innerWidth;
            this.setSidebarWidth();
        },
        setSidebarWidth() {
            if (this.windowWidth < 1200) {
                if (this.windowWidth < 992) this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'md')
                else this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'lg')

                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)
                if (this.reduceButton) this.reduce = false;
                // this.reduceButton = false;
                this.showCloseButton = true;
                this.clickNotClose = false;
                this.$store.dispatch('updateSidebarWidth', 'no-sidebar')
                this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
            }
            else {
                this.$store.commit('UPDATE_WINDOW_BREAKPOINT', 'xl')
                if (this.reduceButton) this.reduce = true;
                else this.reduce = false;

                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true)
                if (this.reduceButton && !this.isMouseEnter) this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true)
                else this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)

                this.clickNotClose = true;
                this.showCloseButton = false;
                if (this.reduceSidebar)
                    this.$store.dispatch('updateSidebarWidth', 'reduced')
                else
                    this.$store.dispatch('updateSidebarWidth', 'default')
            }
        },
        psSectionScroll() {
            if (this.$refs.mainSidebarPs.$el.scrollTop > 0) this.showShadowBottom = true;
            else this.showShadowBottom = false;
        },
        onSwipeLeft() {
            if (this.isSidebarActive && this.showCloseButton) this.isSidebarActive = false
        },
        onSwipeRightSidebarSwipeArea() {
            if (!this.isSidebarActive && this.showCloseButton) this.isSidebarActive = true
        },
        canSee(item) {
            this.$acl.check(this.$store.state.userRole);
            if (!item.role) return true

            return this.$acl.check(item.role)
        },
        addStoreMenu() {
            let items = [...this.sidebarItems]
            let userRole = this.$store.state.auth.userRole

            items.push({
                url: { name: 'dashboard-analytics' },
                name: "Dashboard",
                slug: 'dashboard',
                icon: "HomeIcon",
                i18n: "Dashboard",
            })
            items.push({
                url: null,
                name: "Entity",
                slug: 'entity',
                icon: "GridIcon",
                i18n: "Entity",
                submenu: [
                    {
                        url: { name: 'entity-new' },
                        name: "Add",
                        slug: 'entity-new',
                        i18n: "Add",
                    },
                    {
                        url: { name: 'entity-list' },
                        name: "List",
                        slug: 'entity-list',
                        i18n: "List ",
                    },
                ]
            })
            items.push({
                url: null,
                name: "Portfolio",
                slug: 'portfolio',
                icon: "GridIcon",
                i18n: "Portfolio",
                submenu: [
                    {
                        url: { name: 'portfolio-new' },
                        name: "Add",
                        slug: 'portfolio-new',
                        i18n: "Add",
                    },
                    {
                        url: { name: 'portfolio-list' },
                        name: "List",
                        slug: 'portfolio-list',
                        i18n: "List ",
                    },
                ]
            })
            items.push({
                url: null,
                name: "Broker",
                slug: 'broker',
                icon: "GridIcon",
                i18n: "Broker",
                submenu: [
                    {
                        url: { name: 'broker-new' },
                        name: "Add",
                        slug: 'broker-new',
                        i18n: "Add",
                    },
                    {
                        url: { name: 'broker-list' },
                        name: "List",
                        slug: 'broker-list',
                        i18n: "List ",
                    },
                ]
            })
            items.push({
                url: null,
                name: "Demat Account",
                slug: 'demat-account',
                icon: "GridIcon",
                i18n: "Demat Account",
                submenu: [
                    {
                        url: { name: 'demat-account-new' },
                        name: "Add",
                        slug: 'demat-account-new',
                        i18n: "Add",
                    },
                    {
                        url: { name: 'demat-account-list' },
                        name: "List",
                        slug: 'demat-account-list',
                        i18n: "List ",
                    },
                ]
            })
            items.push({
                url: null,
                name: "Share",
                slug: 'share',
                icon: "GridIcon",
                i18n: "Share",
                submenu: [
                    {
                        url: { name: 'share-new' },
                        name: "Add",
                        slug: 'share-new',
                        i18n: "Add",
                    },
                    {
                        url: { name: 'share-list' },
                        name: "List",
                        slug: 'share-list',
                        i18n: "List ",
                    },
                ]
            })
            items.push({
                url: null,
                name: "Contract",
                slug: 'contract',
                icon: "GridIcon",
                i18n: "Contract",
                submenu: [
                    {
                        url: { name: 'contract-new' },
                        name: "Add",
                        slug: 'contract-new',
                        i18n: "Add",
                    },
                    {
                        url: { name: 'contract-list' },
                        name: "List",
                        slug: 'contract-list',
                        i18n: "List ",
                    },
                ]
            })
            items.push({
                url: null,
                name: "Report",
                slug: 'Report',
                icon: "GridIcon",
                i18n: "Report",
                submenu: [
                    {
                        url: { name: 'transaction-report' },
                        name: "Transaction Report",
                        slug: 'transaction-report',
                        i18n: "Transaction Report",
                    },
                    {
                        url: { name: 'summary-report' },
                        name: "Summary Report",
                        slug: 'summary-report',
                        i18n: "Summary Report",
                    },
                    // {
                    //     url: { name: 'scrip-fifo-report' },
                    //     name: "Scrip FIFO Report",
                    //     slug: 'scrip-fifo-report',
                    //     i18n: "Scrip FIFO Report",
                    // },
                    {
                        url: { name: 'live-scrip-fifo-report' },
                        name: "Live Scrip FIFO Report",
                        slug: 'live-scrip-fifo-report',
                        i18n: "Live Scrip FIFO Report",
                    },
                    {
                        url: { name: 'holding-report' },
                        name: "Holding Report",
                        slug: 'holding-report',
                        i18n: "Holding Report",
                    },
                    {
                        url: { name: 'capital-gain-report' },
                        name: "Capital Gain Report",
                        slug: 'capital-gain-report',
                        i18n: "Capital Gain Report",
                    },
                ]
            })

            items.push({
                url: null,
                name: "Corporate Actions",
                slug: "Corporate Actions",
                icon: "GridIcon",
                i18n: "Corporate Actions",
                submenu: [
                    {
                        url: { name: 'bonus-corporate-action' },
                        name: "Bonus Action",
                        slug: 'bonus-corporate-action',
                        i18n: "Bonus Action",
                    },
                    {
                        url: { name: 'split-corporate-action' },
                        name: "Split Action",
                        slug: 'split-corporate-action',
                        i18n: "Split Action",
                    },
                    {
                        url: { name: 'demerge-corporate-action' },
                        name: "Demerge Action",
                        slug: 'demerge-corporate-action',
                        i18n: "Demerge Action",
                    },
                    {
                        url: { name: 'merge-corporate-action' },
                        name: "Merge Action",
                        slug: 'merge-corporate-action',
                        i18n: "Merge Action",
                    },
                    {
                        url: { name: 'corporate-action-list' },
                        name: "List",
                        slug: 'corporate-action-list',
                        i18n: "List",
                    }
                ]
            })

            items.push({
                url: { name: 'reports-download' },
                name: "Exports",
                icon: "GridIcon",
                slug: 'Exports',
                i18n: "Exports",
            })

            this.finalSidebarItems = items
        }
    },
    components: {
        VxSidebarGroup,
        VxSidebarItem,
        VuePerfectScrollbar,
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleWindowResize);
        });
        this.setSidebarWidth();
        this.addStoreMenu();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxSidebar.scss"
</style>